import * as Yup from 'yup';
import { validatePhoneNumber } from './Utils';

class InputValidatorsClass {
    name = Yup.string()
        .required('Required')
        .matches(/[A-Za-z]+/, 'Name must contain only letters');
    date = Yup.string()
        .required('Date of Birth is required')
        .matches(/^\d{4}-\d{2}-\d{2}$/, 'Date of Birth must be in the format YYYY-MM-DD');
    kraPinRequired = Yup.string()
        .required('Required')
        .matches(/^[AP]{1}[0-9]{9}[a-zA-Z]{1}$/, 'Invalid KRA number format');
    kraPinOptional = Yup.string().matches(/^[A]{1}[0-9]{9}[a-zA-Z]{1}$/, 'Invalid KRA number format');
    email = Yup.string().required('Required').email('Invalid email');
    emailOptional = Yup.string().email('Invalid email');
    requiredString = Yup.string().required('Required');
    passport = Yup.string().required('Required');
    // .matches(/[A-Z]{1}[0-9]{7}/, 'Invalid passport number');
    phone = Yup.string()
        .required('Phone Number is required')
        .test('is-valid-number', 'Please enter a valid phone number', (value) => validatePhoneNumber(value));
    phoneOptional = Yup.string();
    string = Yup.string();
    optionalField = Yup.string().notRequired();
    optionalObjectField = Yup.object().nullable().optional();
}

export const InputValidators = new InputValidatorsClass();
